import { BUSINESS_HOURS, COMPANY } from '@/mocks/home';

export default function BusinessInfo() {
  return (
    <section id="contact" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="text-center">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">Visit Or Call Us</span>
          <h2 className="mt-3 font-heading text-3xl font-extrabold text-primary-800 md:text-4xl">Business Info</h2>
          <div className="mx-auto mt-4 h-1 w-20 rounded-full bg-accent-500"></div>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-2">
          {/* Map */}
          <div className="overflow-hidden rounded-lg border border-background-200">
            <iframe
              title="Crystal Clean Fort Myers location map"
              src="https://www.google.com/maps?q=2420+Concorde+Dr+%236+Fort+Myers+FL+33901&output=embed"
              width="100%"
              height="100%"
              className="h-72 w-full lg:h-full"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          {/* Info */}
          <div className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
              <div>
                <h3 className="flex items-center gap-2 font-heading text-sm font-bold uppercase tracking-wider text-primary-700">
                  <i className="ri-map-pin-line text-accent-600"></i> Fort Myers
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-700">{COMPANY.address}</p>
                <a
                  href={COMPANY.phoneHref}
                  className="mt-3 flex items-center gap-2 text-sm font-semibold text-primary-700 hover:text-accent-600"
                >
                  <i className="ri-phone-line"></i> {COMPANY.phone}
                </a>
              </div>
              <div>
                <h3 className="flex items-center gap-2 font-heading text-sm font-bold uppercase tracking-wider text-primary-700">
                  <i className="ri-map-pin-line text-accent-600"></i> Naples
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-700">{COMPANY.addressNaples}</p>
                <a
                  href={`tel:${COMPANY.naplesPhone.replace(/\./g, '')}`}
                  className="mt-3 flex items-center gap-2 text-sm font-semibold text-primary-700 hover:text-accent-600"
                >
                  <i className="ri-phone-line"></i> {COMPANY.naplesPhone}
                </a>
              </div>
            </div>

            <div className="mt-6 flex items-center gap-2 border-t border-background-300 pt-6 text-sm">
              <i className="ri-mail-line text-accent-600"></i>
              <a href={`mailto:${COMPANY.email}`} className="break-all font-semibold text-primary-700 hover:text-accent-600">
                {COMPANY.email}
              </a>
            </div>

            <h3 className="mt-6 font-heading text-sm font-bold uppercase tracking-wider text-primary-700">
              Business Hours
            </h3>
            <ul className="mt-3 divide-y divide-background-300 rounded-md border border-background-300 bg-background-50">
              {BUSINESS_HOURS.map((h) => (
                <li key={h.day} className="flex items-center justify-between px-4 py-3 text-sm">
                  <span className="font-medium text-foreground-700">{h.day}</span>
                  <span className={h.time === 'Closed' ? 'text-foreground-500' : 'font-semibold text-primary-700'}>
                    {h.time}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}